<template>
  <div class="product-container"> 
    <nav class="add-navigation">
      <div @click="() => toBack()"
           class="back-link">
        <svg class="icon"
             width="30px"
             height="30px"
             viewBox="0 0 30 30"
             version="1.1">
          <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                id="path-1">
          </path>
        </svg>
        <p>Back to Products</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-product'})"
             class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button" @click="handleAddProduct">
          <primary-button>{{ activeComponent === 'edit-product' ? 'Save Product' : 'Submit'}}</primary-button>
        </div>
      </div>
    </nav>
    <div class="content">
      <nav class="nav-header">
        <p @click="handleChangeTab('edit-product')"
          :class="activeComponent === 'edit-product' ? 'active' : ''">Basic Info</p>
        <p @click="handleChangeTab('edit-rate')"
          :class="activeComponent === 'edit-rate' ? 'active' : ''">Rates and Route</p>
      </nav>
      <component :is="activeComponent" ref="form"/>
      <!-- <add-product v-show="activeComponent === 'add-product'" ref="form1"></add-product>
      <add-rate v-show="activeComponent === 'add-rate'" ref="form2"></add-rate> -->
    </div>
  </div>
  
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    EditProduct: () => import("./EditProduct"),
    EditRate: () => import("./EditRate"),
  },
  data: () => ({
    showSms: true,
    activeComponent: 'edit-product',
    isProductAdded: false,
  }),
  computed: {
  },
  methods: {
    ...mapActions({
      updateProduct: 'products/updateProduct',
      resetProductState: 'products/resetProductState',
      resetRateState: 'rates/resetRateState',
      resetMobileNetworkState: 'mobileNetwork/resetMobileNetworkState',
    }),
    toBack() {
      this.updateProduct({});
      this.$router.push({ name: "reseller-product" });
    },
    handleAddProduct:async function() {
      const res = await this.$refs.form.save();

      if(res.isProductAdded) {
        this.isProductAdded = res.isProductAdded;
        this.activeComponent = 'edit-rate'
      } else {
        this.isProductAdded = false; // ??
      }
      console.log("isAdded::: ", res);
    },
    handleChangeTab(component) {
      // this.$refs.form.validate();

      // if(!this.isProductAdded && component === 'edit-rate') {
      //  this.$warning('Add Product Basic Info to proceed');
      //  return
      // }
      // if(this.isProductAdded && component === 'edit-product') {
      //  return
      // }

      this.activeComponent = component;
    },
  },
  beforeRouteLeave (to, from , next) {
    this.resetProductState();
    this.resetRateState();
    this.resetMobileNetworkState();
    next();
  }
}
</script>

<style lang="scss" scoped>
.product-container {
  .content {
    height: fit-content;
    .nav-header {
      height: 50px;
      background-color: #fff;
      padding: 0px 15px 0px 15px;
      display: flex;
      p {
        cursor: pointer;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0px 5px 0px 5px;
        color: #bdbfd8;
        font-family: ""Helvetica Neue"";
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        margin-right: 10px;
        margin-bottom: 0;
      }
      .active {
        color: #51a3f3;
        border-bottom: 2px solid #51a3f3;
      }
    }
  }
  
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin: 20px 0;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 132px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
}
</style>

